import * as React from "react";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";

export interface TodaysProgressBarState {
    expectedProgress: number;
    actualProgress: number;
    show: boolean;
}

class TodaysProgressBar extends React.PureComponent<
    {},
    TodaysProgressBarState
> {
    constructor(props: {}) {
        super(props);
        this.state = {
            expectedProgress: 0,
            actualProgress: 0,
            show: false,
        };
    }

    componentDidMount() {
        State.ShareClass(ESharedComponent.TodaysProgressBar, this);
    }

    componentDidUpdate() {
        State.ShareClass(ESharedComponent.TodaysProgressBar, this);
    }

    render() {
        return null;
    }
}

export default TodaysProgressBar;
